import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

export enum ToggleHexColor {
  BLUE = '#1100DB',
  GREEN = '#14E25A',
}

export enum ToggleSize {
  SMALL = 'small',
  LARGE = 'large',
}

@Component({
  standalone: true,
  selector: 'app-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.css'],
  imports: [CommonModule],
})
export class ToggleComponent {
  @Input() checked = false;
  @Input() color = ToggleHexColor.BLUE;
  @Input() disabled = false;
  @Input() name!: string;
  @Input() testId!: string;
  @Input() set size(val: ToggleSize) {
    this.sizeClass = val;
    if (val === ToggleSize.SMALL) {
      this.svgDimension = 22;
    }
  }
  @Output() handleChecked = new EventEmitter<void>();
  toggleColor = ToggleHexColor;
  toggleSize = ToggleSize;
  sizeClass = ToggleSize.LARGE;
  svgDimension = 28;

  emitCheck() {
    this.handleChecked.emit();
  }
}
